import React, { useEffect, useRef, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ArenaModal from "../common/ArenaModal";
import axiosURLS from "../services/Api";
import { Formik, Form, ErrorMessage } from "formik";
import Input from "../common/InputCustom";
import toast from "react-hot-toast";
import Navbar from "./Navbar";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaAngleDown, FaMapMarkerAlt, FaCalendarAlt, FaClock, FaChevronLeft, FaUser, FaPhone } from "react-icons/fa";
import * as Yup from "yup";
import ConfirmModal from "../common/ConfirmModal";
import { motion, AnimatePresence } from "framer-motion";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { quotePrice } from "../pricing/priceEngine";
interface SlotAvailability { totalSlots: number; availableSlots: number; }
interface BookingDetails { id: string; name: string; mobile: string; startTime: string; }

const initialValues = { fullName: "", mobileNumber: "+91", email: "", bookingTime: "", id: "", name: "" };

const FONT_HEADING = { fontFamily: "'Impact','Arial Black',sans-serif" } as const;
const FONT_MONO   = { fontFamily: "'Courier New',monospace" } as const;

function slotParts(slot: string): { time: string; period: string } {
  const h = parseInt(slot, 10);
  if (h === 23) return { time: "11:00", period: "pm" };
  if (h >= 12) return { time: `${(h - 12) % 12 || 12}:00`, period: "pm" };
  return { time: `${h % 12 || 12}:00`, period: "am" };
}
function slotLabel(slot: string): string {
  const { time, period } = slotParts(slot);
  return `${time} ${period.toUpperCase()}`;
}

const ProgressBar = ({ step }: { step: number }) => (
  <div className="mb-6">
    <div className="flex gap-2 mb-2">
      {[1,2,3].map((s) => (
        <div key={s} className="flex-1 rounded-full" style={{ height:4, background: s<=step ? "linear-gradient(90deg,#FF5A22 0%,#FF8B5E 100%)" : "rgba(255,255,255,0.1)" }} />
      ))}
    </div>
    <span style={{ ...FONT_MONO, color:"#FF5A22", fontSize:12, fontWeight:600 }}>Step {step} of 3</span>
  </div>
);

const StepHeader = ({ title, sub }: { title: string; sub: string }) => (
  <div className="mb-6">
    <h2 style={{ ...FONT_HEADING, fontSize:32, fontWeight:900, color:"#ffffff", marginBottom:6 }}>{title}</h2>
    <p style={{ color:"#a0aec0", fontSize:15 }}>{sub}</p>
  </div>
);
const MainContent = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<1|2|3>(1);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenSubmit, setIsOpenSubmit] = useState(false);
  const [bookingDetails, setBookingDetails] = useState<BookingDetails>();
  const [selectedOption, setSelectedOption] = useState<any>({});
  const [selectedTime, setSelectedTime] = useState("");
  const [formatDate, setFormatDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [fromDate] = useState<string>(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  });
  const [displayFromDate] = useState<string>(() => {
    const d = new Date();
    const mn = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return `${String(d.getDate()).padStart(2,"0")}/${mn[d.getMonth()]}/${d.getFullYear()}`;
  });
  const [toDate] = useState<string>(() => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth()+1).padStart(2,"0");
    return `${year}-${month}-${new Date(year,parseInt(month),0).getDate()}`;
  });
  const [availabilityData, setAvailabilityData] = useState<any>({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [phone, setPhone] = useState("");
  const [firstEffectCompleted, setFirstEffectCompleted] = useState(false);
  const [slotwiseAvailability, setSlotwiseAvailability] = useState<{[key:string]:SlotAvailability}>({});
  const [bookedForMinutes, setBookedForMinutes] = useState(0);
  const [selectedSlots, setSelectedSlots] = useState<any>([]);
  const [price, setPrice] = useState<any>([]);
  const [isTuesday, setIsTuesday] = useState(false);
  // playerCount is null until the user explicitly selects — it's mandatory before continuing
  const [playerCount, setPlayerCount] = useState<number | null>(null);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);
  const [whatsAppOptIn, setWhatsAppOptIn] = useState(true);
  const currentTime: Date = new Date();
  const currentHour = currentTime.getHours();

  // Forward booking limit: allow up to 14 days ahead
  const maxBookingDate = new Date();
  maxBookingDate.setDate(maxBookingDate.getDate() + 14);

  const closeModal = () => { setIsOpenSubmit(false); navigate("/"); };
  const step2BottomRef = useRef<HTMLDivElement>(null);
  const handleOptionSelect = (option: string) => { setSelectedOption(option); setIsOpen(false); };
  const getDataForSelectedDate = (d: any) => availabilityData[d] || {};

  function getNumericSlot(slot: string, availability: SlotAvailability) {
    const map: {[k:string]:number} = {
      TEN_AM_TO_ELEVEN_AM:10, ELEVEN_AM_TO_TWELVE_PM:11, TWELVE_PM_TO_ONE_PM:12,
      ONE_PM_TO_TWO_PM:13, TWO_PM_TO_THREE_PM:14, THREE_PM_TO_FOUR_PM:15,
      FOUR_PM_TO_FIVE_PM:16, FIVE_PM_TO_SIX_PM:17, SIX_PM_TO_SEVEN_PM:18,
      SEVEN_PM_TO_EIGHT_PM:19, EIGHT_PM_TO_NINE_PM:20, NINE_PM_TO_TEN_PM:21,
      TEN_PM_TO_ELEVEN_PM:22, ELEVEN_PM_TO_TWELVE_AM:23,
    };
    const n = map[slot] ?? NaN;
    return { numericSlot:n, totalSlots:availability.totalSlots, availableSlots:availability.availableSlots };
  }
  const handleDateSelect = (date: any) => {
    setSelectedTime(""); setSelectedSlots([]);
    if (!date) return;
    setSelectedDate(date);
    const y = date.getFullYear(), m = String(date.getMonth()+1).padStart(2,"0"), d = String(date.getDate()).padStart(2,"0");
    const fd = `${y}-${m}-${d}`;
    setFormatDate(fd);
    if (!selectedOption) return;
    const sd = getDataForSelectedDate(fd);
    const upd: {[k:string]:SlotAvailability} = {};
    if (sd && sd.slotwiseAvailability) {
      for (const [slot, avail] of Object.entries(sd.slotwiseAvailability)) {
        const { numericSlot, totalSlots, availableSlots } = getNumericSlot(slot, avail as SlotAvailability);
        if (!isNaN(numericSlot)) upd[String(numericSlot)] = { totalSlots, availableSlots };
      }
      setSlotwiseAvailability(upd);
    }
    setStep(2);
  };

  useEffect(() => { setIsTuesday(selectedDate.getDay()===2); }, [selectedDate]);

  const displayFormatDate = (ds: string) => {
    const [y,m,d] = ds.split("-");
    const mn = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return `${d}/${mn[parseInt(m,10)-1]}/${y}`;
  };
  const displayFullDate = (date: Date) => {
    const dn = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    const mn = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return `${dn[date.getDay()]}, ${date.getDate()} ${mn[date.getMonth()]} ${date.getFullYear()}`;
  };

  useEffect(() => {
    if (!isOpen && selectedOption) {
      axiosURLS.post("/onlineBooking/getAvailability",{ fromDate, toDate, arenaId: selectedOption.id })
        .then((r) => { setAvailabilityData(r.data.bookingsAvailabilityInfo); setFirstEffectCompleted(true); setIsLoading(false); })
        .catch(()=>{});
      axiosURLS.post("/pricing/search",{ arenaId: selectedOption.name })
        .then((r) => { setPrice(r.data); })
        .catch(()=>{});
    }
  }, [isOpen, selectedOption]);

  useEffect(() => {
    if (firstEffectCompleted) {
      const sd = getDataForSelectedDate(fromDate);
      const upd: {[k:string]:SlotAvailability} = {};
      if (sd && sd.slotwiseAvailability) {
        for (const [slot, avail] of Object.entries(sd.slotwiseAvailability)) {
          const { numericSlot, totalSlots, availableSlots } = getNumericSlot(slot, avail as SlotAvailability);
          if (!isNaN(numericSlot)) upd[String(numericSlot)] = { totalSlots, availableSlots };
        }
        setSlotwiseAvailability(upd);
      }
    }
  }, [firstEffectCompleted, fromDate]);

  const getPricingByType = (pr: any, type: any) =>
    pr.filter((i:any)=>i.pricingType===type && i.amount > 0 && i.fromTime !== i.toTime).map((i:any)=>({amount:i.amount,fromTime:i.fromTime,toTime:i.toTime}));

  // Merge consecutive rows that have the same amount into a single entry
  const deduplicatePricingRows = (rows: any[]): any[] => {
    if (rows.length === 0) return rows;
    const result = [{ ...rows[0] }];
    for (let i = 1; i < rows.length; i++) {
      const last = result[result.length - 1];
      if (rows[i].amount === last.amount) {
        last.toTime = rows[i].toTime;
      } else {
        result.push({ ...rows[i] });
      }
    }
    return result;
  };

  const normalPricing  = deduplicatePricingRows(getPricingByType(price,"NORMAL"));
  const weekendPricing = deduplicatePricingRows(getPricingByType(price,"WEEKEND"));
  const specialPricing = deduplicatePricingRows(getPricingByType(price,"SPECIAL"));

  const formatTime = (time: string): string => {
    const [h,min] = time.split(":").map(Number);
    return `${h%12||12}:${String(min).padStart(2,"0")} ${h>=12?"PM":"AM"}`;
  };
  const handleSelectedTime = (event: any) => {
    const sel = event.target.value;
    const rem = slotwiseAvailability[sel]?.availableSlots;
    const isCont = (slots: string[]) => { for (let i=1;i<slots.length;i++) { if (parseInt(slots[i])!==parseInt(slots[i-1])+1) return false; } return true; };
    if (rem && rem>0) {
      if (selectedSlots.includes(sel)) {
        const upd = selectedSlots.filter((s:any)=>s!==sel);
        upd.sort((a:string,b:string)=>parseInt(a)-parseInt(b));
        if (!isCont(upd)) { setSelectedSlots([]); setBookedForMinutes(0); setSelectedTime(""); toast("Please select time slots in sequence."); }
        else { setSelectedSlots(upd); setSelectedTime(upd[0]||""); setBookedForMinutes(upd.length*60); }
      } else {
        const last = selectedSlots.length>0 ? parseInt(selectedSlots[selectedSlots.length-1]) : null;
        const curr = parseInt(sel);
        if (last===null||curr===last+1||curr===last-1) {
          const upd = [...selectedSlots, sel];
          upd.sort((a:string,b:string)=>parseInt(a)-parseInt(b));
          if (!isCont(upd)) { setSelectedSlots([]); setBookedForMinutes(0); setSelectedTime(""); toast("Please select time slots in sequence."); }
          else { setSelectedSlots(upd); setSelectedTime(upd[0]); setBookedForMinutes(upd.length*60); }
        } else { toast("Please select slots in sequence."); }
      }
    } else { toast("No slots available for this time slot",{icon:"😔"}); }
    // Scroll to bottom so user sees summary + CTA without manual scrolling
    setTimeout(() => { step2BottomRef.current?.scrollIntoView({ behavior:"smooth", block:"end" }); }, 80);
  };

  const handlePlayerCountChange = (n: number) => {
    setPlayerCount(n);
  };

  function isSpecialDay(date: any) {
    const y=date.getFullYear(), m=date.getMonth()+1, d=date.getDate();
    const fd=`${y}-${String(m).padStart(2,"0")}-${String(d).padStart(2,"0")}`;
    return price.some((p:any)=>p.date===fd);
  }

  // Returns 'nearFull' if max available slots on that date is ≤ 2
  const getTileDotColor = (date: Date): string | null => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const dateStr = `${y}-${m}-${d}`;
    const dayData = availabilityData[dateStr]?.slotwiseAvailability;
    if (!dayData) return null;
    const slots = Object.values(dayData) as SlotAvailability[];
    if (slots.length === 0) return null;
    const available = slots.filter((s) => s.availableSlots > 0);
    if (available.length === 0) return "#ef4444"; // fully booked
    const maxAvail = Math.max(...available.map((s) => s.availableSlots));
    if (maxAvail <= 2) return "#f59e0b"; // near-full amber
    return null;
  };

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().matches(/^[a-zA-Z\s]*$/,"Name can't contain numbers or special characters").min(2,"Your Name is too Short!").max(25,"Your Name is too Long!").required("Name is required"),
    mobileNumber: Yup.string().required("Mobile number is required"),
  });

  // Derived
  const selectedDateFull = displayFullDate(selectedDate);
  const slotTimeRange = selectedSlots.length>0
    ? `${slotLabel(selectedSlots[0])} – ${slotLabel(String(parseInt(selectedSlots[selectedSlots.length-1],10)+1))}`
    : "";
  const durationHours = selectedSlots.length;

  const getPriceForSlot = (h: number): string => {
    // On weekends/special days use those tiers; otherwise normal pricing only
    const isWeekend = selectedDate.getDay() === 0 || selectedDate.getDay() === 6;
    const activeTier = isSpecialDay(selectedDate)
      ? specialPricing
      : isWeekend
      ? weekendPricing
      : normalPricing;
    const m = activeTier.find((p: any) => {
      const f = parseInt(p.fromTime.split(":")[0]);
      const t = parseInt(p.toTime.split(":")[0]);
      return h >= f && h < t;
    });
    return m ? `₹${m.amount}` : "";
  };

  const getActivePricingTier = () => {
    const isWeekend = selectedDate.getDay() === 0 || selectedDate.getDay() === 6;
    if (isSpecialDay(selectedDate)) return { rows: specialPricing, label: "Special Day Rates", color: "#f59e0b" };
    if (isWeekend) return { rows: weekendPricing, label: "Weekend Rates", color: "#10b981" };
    return { rows: normalPricing, label: "Weekday Rates", color: "#2d7a4e" };
  };
  // ---- Sub-components (defined inside to access state) ----
  const SlotCard = ({ slot, availableSlots }: { slot:string; availableSlots:number }) => {
    const isToday = selectedDate.getDate()===currentTime.getDate()&&selectedDate.getMonth()===currentTime.getMonth();
    if (isToday && currentHour>=parseInt(slot,10)) return null;
    const sel=selectedSlots.includes(slot), bkd=availableSlots===0;
    const isWeekendDay = selectedDate.getDay()===0||selectedDate.getDay()===6;
    const fromPrice = isWeekendDay ? 650 : 600;

    let slotPriceDisplay: React.ReactNode;
    if (playerCount === null) {
      slotPriceDisplay = (
        <div className="flex flex-col items-end">
          <span style={{...FONT_MONO,fontSize:12,fontWeight:700,color:sel?"#0f1419":"#FF5A22"}}>
            From ₹{fromPrice}
          </span>
          <span style={{fontSize:10,color:sel?"rgba(15,20,25,0.65)":"#6b7280",marginTop:1}}>per person</span>
        </div>
      );
    } else {
      const slotQuote = quotePrice({date:selectedDate,playerCount,durationMinutes:60});
      const slotTotal = slotQuote.pricePerPerson * playerCount;
      const badge = slotQuote.appliedRuleId==='SOLO_PREMIUM' ? 'Solo'
                  : slotQuote.appliedRuleId==='FIVE_PLAYER_DEAL' ? '5-player' : null;
      slotPriceDisplay = (
        <div className="flex flex-col items-end">
          {badge&&(
            <span style={{background:"rgba(255,90,34,0.18)",color:sel?"#0f1419":"#FF5A22",fontSize:9,fontWeight:700,
              borderRadius:4,padding:"1px 5px",marginBottom:2,textTransform:"uppercase",letterSpacing:"0.04em"}}>
              {badge}
            </span>
          )}
          <span style={{...FONT_MONO,fontSize:13,fontWeight:700,color:sel?"#0f1419":"#FF5A22"}}>
            ₹{slotTotal}
          </span>
          <span style={{fontSize:10,color:sel?"rgba(15,20,25,0.65)":"#6b7280",marginTop:1}}>
            1 hr · {playerCount}p
          </span>
        </div>
      );
    }

    return (
      <div className="relative rounded-2xl p-4 flex flex-col justify-between transition-all duration-200"
        style={{ minHeight:90, background:sel?"linear-gradient(135deg,#FF5A22 0%,#FF8B5E 100%)":bkd?"#111620":"#1a1f29",
          border:bkd?"1.5px solid rgba(255,255,255,0.04)":sel?"1.5px solid transparent":"1.5px solid rgba(255,90,34,0.22)",
          borderTop:(!bkd&&!sel)?"1px solid rgba(255,255,255,0.08)":undefined,
          boxShadow:(!bkd&&!sel)?"0 1px 3px rgba(0,0,0,0.50), 0 6px 18px rgba(0,0,0,0.40), 0 16px 40px rgba(0,0,0,0.25)":sel?"0 4px 20px rgba(255,90,34,0.3)":undefined,
          opacity:bkd?0.55:1, cursor:bkd?"not-allowed":playerCount===null?"default":"pointer" }}
        onClick={() => {
          if (bkd) return;
          if (playerCount === null) { toast("Please select number of players first", { icon: "👆" }); return; }
          handleSelectedTime({ target: { value: slot } } as any);
        }}
      >
        {sel&&(<svg className="absolute top-2 right-2 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="#0f1419" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"/></svg>)}
        <div style={{...FONT_MONO,display:"flex",flexDirection:"column",lineHeight:1.1}}>
          <span style={{fontWeight:700,fontSize:15,color:sel?"#0f1419":"#ffffff"}}>{slotParts(slot).time}</span>
          <span style={{fontWeight:600,fontSize:10,color:sel?"rgba(15,20,25,0.65)":"#6b7280",marginTop:1}}>{slotParts(slot).period}</span>
        </div>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <div className="rounded-full" style={{width:6,height:6,background:sel?"#0f1419":bkd?"#ef4444":"#10b981"}}/>
            <span style={{fontSize:12,color:sel?"#0f1419":"#a0aec0"}}>{bkd?"Booked":`${availableSlots} left`}</span>
          </div>
          {slotPriceDisplay}
        </div>
        <input type="checkbox" name="timeSlot" value={slot} checked={sel} onChange={()=>{}} className="sr-only"/>
      </div>
    );
  };

  const SlotGrid = () => {
    const entries = Object.entries(slotwiseAvailability);
    if (isLoading) return (
      <div className="grid grid-cols-2 gap-3">
        {Array.from({length:8}).map((_,i)=>(
          <SkeletonTheme key={i} baseColor="#252d3a" highlightColor="#1a1f29"><Skeleton height={90} borderRadius={16}/></SkeletonTheme>
        ))}
      </div>
    );
    if (entries.length===0) return <div className="flex justify-center items-center h-40"><div className="loader"/></div>;
    const visible = entries.filter(([slot])=>{
      const isToday=selectedDate.getDate()===currentTime.getDate()&&selectedDate.getMonth()===currentTime.getMonth();
      return !(isToday&&currentHour>=parseInt(slot,10));
    });
    if (visible.length>0&&visible.every(([,{availableSlots}])=>availableSlots===0)) return (
      <div className="rounded-2xl p-6 text-center" style={{background:"#1a1f29",border:"1.5px solid rgba(255,255,255,0.1)"}}>
        <p style={{color:"#ef4444",fontWeight:700,fontSize:15}}>All bays are fully booked.</p>
        <p style={{color:"#a0aec0",fontSize:13,marginTop:4}}>Please select another date.</p>
      </div>
    );
    return (<div className="grid grid-cols-2 gap-3">{entries.map(([slot,{availableSlots}])=>(<SlotCard key={slot} slot={slot} availableSlots={availableSlots}/>))}</div>);
  };
  // ---- JSX helpers ----
  const BackBtn = () => (
    <button onClick={()=>{ if(step===1) navigate("/"); else setStep((step-1) as 1|2|3); }}
      className="flex items-center justify-center rounded-xl transition-all"
      style={{width:40,height:40,background:"#1a1f29",border:"1.5px solid rgba(255,255,255,0.1)",flexShrink:0}}>
      <FaChevronLeft style={{color:"#ffffff",fontSize:14}}/>
    </button>
  );

  const ArenaChip = () => selectedOption?.name ? (
    <div className="flex items-center gap-2 rounded-xl px-4 py-2 mb-6 cursor-pointer"
      style={{background:"#1a1f29",border:"1.5px solid rgba(255,90,34,0.22)",borderTop:"1px solid rgba(255,255,255,0.08)",display:"inline-flex",boxShadow:"0 2px 8px rgba(0,0,0,0.45)"}}
      onClick={()=>setIsOpen(true)}>
      <FaMapMarkerAlt style={{color:"#2d7a4e",fontSize:14}}/>
      <span style={{color:"#ffffff",fontSize:14,fontWeight:600}}>{selectedOption.name}</span>
      {selectedOption.contactDetail?.mobileNumber && (
        <>
          <span style={{color:"rgba(255,255,255,0.2)",fontSize:12}}>·</span>
          <a
            href={`tel:${selectedOption.contactDetail.mobileNumber}`}
            onClick={(e) => e.stopPropagation()}
            className="flex items-center gap-1"
            style={{
              color:"#FF5A22",
              fontSize:12,
              fontWeight:600,
              background:"rgba(255,90,34,0.12)",
              border:"1px solid rgba(255,90,34,0.25)",
              borderRadius:6,
              padding:"2px 7px",
              textDecoration:"none",
            }}
          >
            <FaPhone style={{fontSize:9}}/>
            {selectedOption.contactDetail.mobileNumber}
          </a>
        </>
      )}
      <FaAngleDown style={{color:"#a0aec0",fontSize:12}}/>
    </div>
  ) : null;

  const DateChip = () => (
    <div className="flex items-center gap-3 rounded-xl px-4 py-3 mb-6" style={{background:"#1a1f29",border:"1.5px solid rgba(255,90,34,0.22)",borderTop:"1px solid rgba(255,255,255,0.08)",boxShadow:"0 2px 8px rgba(0,0,0,0.45)"}}>
      <div className="flex items-center justify-center rounded-xl" style={{width:36,height:36,background:"rgba(45,122,78,0.15)"}}>
        <FaCalendarAlt style={{color:"#2d7a4e",fontSize:14}}/>
      </div>
      <div>
        <div style={{color:"#6b7280",fontSize:11,textTransform:"uppercase",letterSpacing:"0.06em"}}>Selected date</div>
        <div style={{color:"#ffffff",fontWeight:600,fontSize:15}}>{selectedDateFull}</div>
      </div>
    </div>
  );

  const SummaryCard = () => selectedSlots.length>0 ? (
    <div className="rounded-2xl p-4 mt-4 mb-2" style={{background:"#1a1f29",border:"1.5px solid rgba(255,90,34,0.22)",borderTop:"1px solid rgba(255,255,255,0.08)",boxShadow:"0 1px 3px rgba(0,0,0,0.50), 0 6px 18px rgba(0,0,0,0.40), 0 16px 40px rgba(0,0,0,0.25)"}}>
      <div className="flex justify-between items-center mb-2">
        <span style={{color:"#6b7280",fontSize:13}}>Duration</span>
        <span style={{color:"#ffffff",fontWeight:600,fontSize:14}}>{durationHours} hour{durationHours!==1?"s":""}</span>
      </div>
      <div style={{height:1,background:"rgba(255,255,255,0.06)",marginBottom:8}}/>
      <div className="flex justify-between items-center">
        <span style={{color:"#6b7280",fontSize:13}}>Time</span>
        <span style={{...FONT_MONO,color:"#FF5A22",fontWeight:700,fontSize:14}}>{slotTimeRange}</span>
      </div>
    </div>
  ) : null;

  // Compute total price using the pricing engine — player-count and day-type aware
  const activeQuote = (selectedSlots.length > 0 && playerCount !== null)
    ? quotePrice({ date: selectedDate, playerCount, durationMinutes: bookedForMinutes })
    : null;
  const totalPrice: number = activeQuote?.total ?? 0;

  const TotalPriceCard = () => (activeQuote !== null && totalPrice > 0) ? (
    <motion.div
      key={`total-${totalPrice}-${playerCount}`}
      initial={{opacity:0, y:10, scale:0.97}}
      animate={{opacity:1, y:0, scale:1}}
      transition={{type:"spring", stiffness:300, damping:24}}
      className="rounded-2xl px-4 py-4 mt-3"
      style={{background:"linear-gradient(135deg,rgba(255,90,34,0.10) 0%,rgba(255,90,34,0.05) 100%)",border:"1.5px solid rgba(255,90,34,0.22)",borderTop:"1px solid rgba(255,90,34,0.30)",boxShadow:"0 1px 3px rgba(0,0,0,0.50), 0 6px 18px rgba(0,0,0,0.40), 0 16px 40px rgba(0,0,0,0.25)"}}
    >
      <div className="flex items-center justify-between">
        <div>
          <div style={{color:"#a0aec0",fontSize:11,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:4}}>Estimated Total</div>
          <div style={{color:"#6b7280",fontSize:12}}>
            {durationHours} hr{durationHours!==1?"s":""} {" · "} {playerCount} player{playerCount!==1?"s":""} {" · "} {slotTimeRange}
          </div>
        </div>
        <div className="flex items-baseline gap-1">
          <span style={{...FONT_MONO,color:"#a0aec0",fontSize:14}}>{"₹"}</span>
          <span style={{...FONT_HEADING,color:"#FF5A22",fontSize:36,fontWeight:900,lineHeight:1}}>{totalPrice}</span>
        </div>
      </div>
      <div style={{height:1,background:"rgba(255,90,34,0.15)",margin:"10px 0"}}/>
      {(activeQuote.appliedRuleId==='SOLO_PREMIUM'||activeQuote.appliedRuleId==='FIVE_PLAYER_DEAL')&&(
        <div className="flex items-center gap-2 mb-2">
          <span style={{background:"rgba(255,90,34,0.18)",color:"#FF5A22",fontSize:10,fontWeight:700,
            borderRadius:4,padding:"2px 7px",textTransform:"uppercase",letterSpacing:"0.04em"}}>
            {activeQuote.appliedRuleId==='SOLO_PREMIUM'?"Solo premium applied":"5-player deal applied"}
          </span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{flexShrink:0}}>
          <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="#FF5A22" strokeWidth="1.5"/>
          <path d="M12 8v4m0 4h.01" stroke="#FF5A22" strokeWidth="2" strokeLinecap="round"/>
        </svg>
        <span style={{color:"#6b7280",fontSize:11}}>Price per bay {"·"} up to 5 players</span>
      </div>
    </motion.div>
  ) : null;

  const BookingRecap = () => (
    <div className="rounded-2xl p-4 mb-6" style={{background:"#252d3a",border:"1.5px solid rgba(255,255,255,0.08)",borderTop:"1px solid rgba(255,255,255,0.12)",boxShadow:"0 1px 3px rgba(0,0,0,0.50), 0 6px 18px rgba(0,0,0,0.40), 0 16px 40px rgba(0,0,0,0.25)"}}>
      <div style={{color:"#6b7280",fontSize:11,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>Booking Summary</div>
      <div className="space-y-2">
        {selectedOption?.name&&(<div className="flex items-center gap-2"><FaMapMarkerAlt style={{color:"#2d7a4e",fontSize:12}}/><span style={{color:"#ffffff",fontSize:14,fontWeight:600}}>{selectedOption.name}</span></div>)}
        <div className="flex items-center gap-2"><FaCalendarAlt style={{color:"#2d7a4e",fontSize:12}}/><span style={{color:"#a0aec0",fontSize:13}}>{selectedDateFull}</span></div>
        {slotTimeRange&&(<div className="flex items-center gap-2"><FaClock style={{color:"#2d7a4e",fontSize:12}}/><span style={{...FONT_MONO,color:"#FF5A22",fontSize:14,fontWeight:700}}>{slotTimeRange}</span><span style={{color:"#6b7280",fontSize:12}}>{"· "}{durationHours}h</span></div>)}
        {playerCount!==null&&(
          <div className="flex items-center gap-2 flex-wrap">
            <FaUser style={{color:"#2d7a4e",fontSize:12}}/>
            <span style={{color:"#a0aec0",fontSize:13}}>{playerCount} player{playerCount!==1?"s":""}</span>
            {activeQuote&&(activeQuote.appliedRuleId==='SOLO_PREMIUM'||activeQuote.appliedRuleId==='FIVE_PLAYER_DEAL')&&(
              <span style={{background:"rgba(255,90,34,0.18)",color:"#FF5A22",fontSize:10,fontWeight:700,
                borderRadius:4,padding:"1px 5px",textTransform:"uppercase",letterSpacing:"0.04em"}}>
                {activeQuote.appliedRuleId==='SOLO_PREMIUM'?"Solo premium":"5-player deal"}
              </span>
            )}
          </div>
        )}
      </div>
      {totalPrice>0&&(
        <>
          <div style={{height:1,background:"rgba(255,255,255,0.06)",margin:"10px 0"}}/>
          <div className="flex justify-between items-center">
            <span style={{color:"#6b7280",fontSize:13}}>Estimated Total</span>
            <span style={{...FONT_MONO,color:"#FF5A22",fontWeight:700,fontSize:16}}>{"₹"}{totalPrice}</span>
          </div>
        </>
      )}
    </div>
  );

  const TuesdayBanner = () => (
    <div className="rounded-2xl p-5 text-center" style={{background:"rgba(239,68,68,0.1)",border:"1.5px solid rgba(239,68,68,0.3)"}}>
      <div style={{fontSize:32}}>🏏</div>
      <p style={{color:"#ef4444",fontWeight:700,fontSize:16,marginTop:8}}>Closed every Tuesday</p>
      <p style={{color:"#a0aec0",fontSize:13,marginTop:4}}>Please select another day to book your bay.</p>
    </div>
  );

  const PlayersSelector = () => (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <span style={{color:"#a0aec0",fontSize:12,textTransform:"uppercase",letterSpacing:"0.07em"}}>Players</span>
        <button
          onClick={() => setPricingModalOpen(true)}
          style={{background:"none",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:4,padding:0}}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="#FF5A22" strokeWidth="1.5"/>
            <path d="M12 8v4m0 4h.01" stroke="#FF5A22" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <span style={{color:"#FF5A22",fontSize:12,fontWeight:600}}>Pricing rules</span>
        </button>
      </div>
      <div className="flex gap-2">
        {[1,2,3,4,5].map(n => {
          const sel = n === playerCount;
          return (
            <button key={n} onClick={() => handlePlayerCountChange(n)}
              className="flex-1 rounded-xl font-bold transition-all active:scale-95"
              style={{
                height:40,
                background:sel?"linear-gradient(135deg,#FF5A22 0%,#FF8B5E 100%)":"#1a1f29",
                color:sel?"#0f1419":"#ffffff",
                border:sel?"1.5px solid transparent":"1.5px solid rgba(255,90,34,0.22)",
                fontSize:15,
                cursor:"pointer",
              }}>
              {n}
            </button>
          );
        })}
      </div>
    </div>
  );

  const PricingModal = () => (
    <AnimatePresence>
      {pricingModalOpen && (
        <>
          <motion.div
            key="backdrop"
            initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}
            onClick={() => setPricingModalOpen(false)}
            style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:50}}
          />
          <motion.div
            key="sheet"
            initial={{y:"100%"}} animate={{y:0}} exit={{y:"100%"}}
            transition={{type:"spring",stiffness:300,damping:30}}
            className="rounded-t-3xl"
            style={{position:"fixed",bottom:0,left:0,right:0,zIndex:51,background:"#1a1f29",
              borderTop:"2px solid rgba(255,90,34,0.35)",padding:"24px 20px 40px",maxWidth:480,margin:"0 auto"}}
          >
            <div className="flex items-center justify-between mb-5">
              <span style={{...FONT_HEADING,fontSize:20,fontWeight:900,color:"#ffffff"}}>Pricing Rules</span>
              <button onClick={() => setPricingModalOpen(false)}
                style={{background:"#252d3a",border:"1.5px solid rgba(255,255,255,0.1)",borderRadius:8,
                  width:32,height:32,color:"#a0aec0",cursor:"pointer",fontSize:16,display:"flex",
                  alignItems:"center",justifyContent:"center"}}>✕</button>
            </div>
            <div className="space-y-3">
              {[
                {label:"Weekday",       desc:"₹600 / person · 1 hr"},
                {label:"Weekend",       desc:"₹650 / person · 1 hr"},
                {label:"Solo premium",  desc:"₹800 total · 1 hr"},
                {label:"5-player deal", desc:"₹500 / person · 1 hr"},
              ].map(({label,desc}) => (
                <div key={label} className="flex items-center justify-between rounded-xl px-4 py-3"
                  style={{background:"#252d3a",border:"1.5px solid rgba(255,90,34,0.12)"}}>
                  <span style={{color:"#ffffff",fontSize:14,fontWeight:600}}>{label}</span>
                  <span style={{...FONT_MONO,color:"#FF5A22",fontSize:14,fontWeight:700}}>{desc}</span>
                </div>
              ))}
            </div>
            <p style={{color:"#6b7280",fontSize:12,marginTop:16,textAlign:"center"}}>
              All prices per bay · up to 5 players
            </p>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );

  // ---- RETURN ----
  return (
    <>
      <Navbar/>
      <div className="min-h-screen pt-20 pb-10" style={{background:"linear-gradient(180deg,#0f1419 0%,#1a1f29 100%)"}}>
        <div className="mx-auto px-5" style={{maxWidth:480}}>

          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <BackBtn/>
            <span style={{...FONT_HEADING,fontSize:22,fontWeight:900,color:"#FF5A22",letterSpacing:"0.06em",textTransform:"uppercase"}}>New Booking</span>
            <div style={{width:40}}/>
          </div>

          <ProgressBar step={step}/>

          <AnimatePresence mode="wait">
            {/* STEP 1 */}
            {step===1&&(
              <motion.div key="s1" initial={{opacity:0,x:30}} animate={{opacity:1,x:0}} exit={{opacity:0,x:-30}} transition={{duration:0.22}}>
                <StepHeader title="Pick a Date" sub="Choose when you want to play"/>
                <ArenaChip/>
                <motion.div
                  initial={{opacity:0,y:16,scale:0.97}}
                  animate={{opacity:1,y:0,scale:1}}
                  transition={{type:"spring",stiffness:260,damping:22,delay:0.05}}
                  className="rounded-2xl overflow-hidden"
                  style={{border:"1.5px solid rgba(255,90,34,0.22)",borderTop:"1px solid rgba(255,255,255,0.08)",background:"#1a1f29",padding:"4px",boxShadow:"0 1px 3px rgba(0,0,0,0.50), 0 6px 18px rgba(0,0,0,0.40), 0 16px 40px rgba(0,0,0,0.25)"}}
                >
                  <Calendar
                    className="w-full"
                    onChange={(value)=>handleDateSelect(value)}
                    value={selectedDate}
                    minDate={new Date()}
                    maxDate={maxBookingDate}
                    onActiveStartDateChange={()=>{}}
                    tileDisabled={({date})=>date.getDay()===2}
                    tileContent={({date, view}) => {
                      if (view !== "month") return null;
                      const dotColor = getTileDotColor(date);
                      if (!dotColor) return null;
                      return (
                        <div style={{
                          width: 5, height: 5,
                          background: dotColor,
                          borderRadius: "50%",
                          margin: "2px auto 0",
                        }}/>
                      );
                    }}
                  />
                </motion.div>
              </motion.div>
            )}

            {/* STEP 2 */}
            {step===2&&(
              <motion.div key="s2" initial={{opacity:0,x:30}} animate={{opacity:1,x:0}} exit={{opacity:0,x:-30}} transition={{duration:0.22}}>
                <StepHeader title="Select Time" sub={selectedDateFull}/>
                <DateChip/>
                {isTuesday ? <TuesdayBanner/> : (
                  <>
                    {!isOpen&&(
                      <>
                        <PlayersSelector/>
                        <SlotGrid/>
                      </>
                    )}
                    <PricingModal/>
                    {Object.keys(slotwiseAvailability).length>0&&!isLoading&&(
                      <div className="flex items-start gap-3 rounded-2xl p-4 mt-4"
                        style={{background:"linear-gradient(135deg,rgba(255,90,34,0.15) 0%,rgba(255,90,34,0.10) 100%)",
                          border:"1.5px solid rgba(255,90,34,0.4)",boxShadow:"0 0 16px rgba(255,90,34,0.08)"}}>
                        <div className="flex-shrink-0 rounded-full flex items-center justify-center"
                          style={{width:32,height:32,background:"rgba(255,90,34,0.2)",marginTop:1}}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="#FF5A22" strokeWidth="2"/>
                            <path d="M12 8v4m0 4h.01" stroke="#FF5A22" strokeWidth="2.5" strokeLinecap="round"/>
                          </svg>
                        </div>
                        <p style={{color:"#FF5A22",fontSize:13,fontWeight:600,lineHeight:1.6}}>
                          Select multiple consecutive slots for longer sessions.{" "}
                          <span style={{color:"#a0aec0",fontWeight:400}}>Tap a selected slot to deselect or select multiple.</span>
                        </p>
                      </div>
                    )}
                    <SummaryCard/>
                    <TotalPriceCard/>
                    {price.length>0&&(()=>{
                      const {rows, label, color} = getActivePricingTier();
                      return rows.length>0 ? (
                        <div className="mt-4 rounded-2xl overflow-hidden" style={{border:"1.5px solid rgba(255,90,34,0.22)",borderTop:"1px solid rgba(255,255,255,0.08)",boxShadow:"0 1px 3px rgba(0,0,0,0.50), 0 6px 18px rgba(0,0,0,0.40), 0 16px 40px rgba(0,0,0,0.25)"}}>
                          <div className="px-4 py-3 flex items-center gap-2" style={{background:"#1a1f29"}}>
                            <div className="rounded-full" style={{width:8,height:8,background:color,flexShrink:0}}/>
                            <p style={{...FONT_HEADING,color:"#ffffff",fontSize:13,letterSpacing:"0.04em"}}>{label}</p>
                          </div>
                          <div className="px-4 pb-4 pt-1" style={{background:"#1a1f29"}}>
                            {rows.map((item:any,i:number)=>(
                              <div key={i} className="flex justify-between items-center py-2" style={{borderBottom:i<rows.length-1?"1px solid rgba(255,255,255,0.05)":"none"}}>
                                <span style={{color:"#a0aec0",fontSize:13}}>{formatTime(item.fromTime)} {"–"} {formatTime(item.toTime)}</span>
                                <div className="flex flex-col items-end">
                                  <span style={{...FONT_MONO,color:"#FF5A22",fontWeight:700,fontSize:14}}>₹{item.amount}</span>
                                  <span style={{color:"#6b7280",fontSize:10}}>per person</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null;
                    })()}
                    {(()=>{
                      const disabled = selectedSlots.length===0 || playerCount===null;
                      const label = selectedSlots.length===0 && playerCount===null
                        ? "Select players & a time slot"
                        : selectedSlots.length===0
                        ? "Select a time slot"
                        : playerCount===null
                        ? "Select number of players"
                        : "Continue to Details →";
                      return (
                        <button className="w-full mt-5 rounded-2xl font-bold transition-all active:scale-95"
                          style={{height:56,background:disabled?"rgba(255,255,255,0.08)":"linear-gradient(135deg,#FF5A22 0%,#FF8B5E 100%)",
                            color:disabled?"#6b7280":"#0f1419",fontSize:16,border:"none",
                            cursor:disabled?"not-allowed":"pointer"}}
                          disabled={disabled}
                          onClick={()=>setStep(3)}>
                          {label}
                        </button>
                      );
                    })()}
                    <div ref={step2BottomRef}/>
                  </>
                )}
              </motion.div>
            )}

            {/* STEP 3 */}
            {step===3&&(
              <motion.div key="s3" initial={{opacity:0,x:30}} animate={{opacity:1,x:0}} exit={{opacity:0,x:-30}} transition={{duration:0.22}}>
                <StepHeader title="Your Details" sub="Almost there! Fill in your info"/>
                <BookingRecap/>
                <Formik initialValues={initialValues} validationSchema={validationSchema}
                  onSubmit={async (values,actions)=>{
                    const bdt=`${selectedDate.getDate()===currentTime.getDate()&&selectedDate.getMonth()===currentTime.getMonth()?fromDate||formatDate:formatDate}T${selectedTime}:00:00+0530`;
                    if(!values.fullName&&phone.length===12){toast.error("Please fill in all fields");return;}
                    if(!phone){toast.error("Please enter a mobile number");return;}
                    if(!selectedTime){toast.error("Please select a time slot");return;}
                    try{
                      const {data}=await axiosURLS.post("/onlineBooking",{
                        firstName:values.fullName,contactDetail:{mobileNumber:`+${phone}`,email:values.email},
                        bookingTime:bdt,whatsAppOptIn,arenaRef:{id:selectedOption.name,name:selectedOption.name},
                        bookingMode:"ONLINE",bookingStatus:"ONLINE_WAITING",onlineBookingStatus:"BOOKED",bookedForMinutes,
                      });
                      actions.setSubmitting(false);actions.resetForm();setPhone("");
                      toast.success("Booked slot successfully");
                      setBookingDetails({id:data.userFriendlyBookingId,name:data.firstName,mobile:data.contactDetail.mobileNumber,startTime:data.bookingTime});
                      setSelectedSlots([]);setIsOpenSubmit(true);
                    }catch(err:any){
                      toast.error(err.response?.data?.message||"Booking failed. Please try again later.");
                      actions.setSubmitting(false);
                    }
                  }}>
                  {({isSubmitting})=>(
                    <Form className="space-y-4">
                      <div>
                        <label className="block mb-2" style={{color:"#a0aec0",fontSize:12,textTransform:"uppercase",letterSpacing:"0.07em"}}>Full Name <span style={{color:"#ef4444"}}>*</span></label>
                        <Input label="" placeholder="Enter your full name" name="fullName" type="text" required/>
                        <ErrorMessage name="fullName" component="div" className="text-red-500 text-xs mt-1"/>
                      </div>
                      <div>
                        <label className="block mb-2" style={{color:"#a0aec0",fontSize:12,textTransform:"uppercase",letterSpacing:"0.07em"}}>Mobile Number <span style={{color:"#ef4444"}}>*</span></label>
                        <PhoneInput country={"in"} value={phone} placeholder="Enter your mobile number" onChange={(p)=>setPhone(p)}/>
                      </div>
                      <div>
                        <label className="block mb-2" style={{color:"#a0aec0",fontSize:12,textTransform:"uppercase",letterSpacing:"0.07em"}}>Email</label>
                        <Input label="" placeholder="Enter your email" name="email" type="text"/>
                        <ErrorMessage name="email" component="div" className="text-red-500 text-xs mt-1"/>
                      </div>
                      {/* WhatsApp opt-in */}
                      <div
                        className="flex items-center gap-3 rounded-2xl px-4 py-3 cursor-pointer"
                        style={{ background: whatsAppOptIn ? "rgba(37,211,102,0.08)" : "#1a1f29", border: whatsAppOptIn ? "1.5px solid rgba(37,211,102,0.3)" : "1.5px solid rgba(255,255,255,0.1)" }}
                        onClick={() => setWhatsAppOptIn(!whatsAppOptIn)}
                      >
                        <div
                          className="flex items-center justify-center rounded"
                          style={{ width: 20, height: 20, background: whatsAppOptIn ? "#25D366" : "transparent", border: whatsAppOptIn ? "none" : "2px solid rgba(255,255,255,0.3)", flexShrink: 0, transition: "all 0.2s" }}
                        >
                          {whatsAppOptIn && (
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M2 6l2.5 2.5L10 3" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          )}
                        </div>
                        <div>
                          <p style={{ color: "#ffffff", fontSize: 13, fontWeight: 600 }}>WhatsApp Reminder</p>
                          <p style={{ color: "#6b7280", fontSize: 11, marginTop: 1 }}>Get notified before your session</p>
                        </div>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill={whatsAppOptIn ? "#25D366" : "#6b7280"} style={{ marginLeft: "auto", flexShrink: 0, transition: "fill 0.2s" }}>
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                        </svg>
                      </div>

                      <button type="submit" disabled={isSubmitting||isTuesday}
                        className="w-full rounded-2xl font-bold transition-all active:scale-95 mt-2"
                        style={{height:56,background:"linear-gradient(135deg,#FF5A22 0%,#FF8B5E 100%)",color:"#0f1419",fontSize:16,border:"none",
                          cursor:isSubmitting||isTuesday?"not-allowed":"pointer",opacity:isSubmitting||isTuesday?0.6:1,
                          boxShadow:"0 8px 24px rgba(255,90,34,0.3)"}}>
                        {isSubmitting?"RESERVING...":"RESERVE NOW"}
                      </button>
                      <p className="text-center text-xs" style={{color:"#f59e0b"}}>Up to 5 persons allowed per bay</p>
                    </Form>
                  )}
                </Formik>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      {isOpen&&<ArenaModal onSelectOption={handleOptionSelect}/>}
      {isOpenSubmit&&(<ConfirmModal onClose={closeModal} //@ts-ignore
        bookingDetails={bookingDetails} arenaPhone={selectedOption?.contactDetail?.mobileNumber} whatsAppOptIn={whatsAppOptIn}/>)}
    </>
  );
};

export default MainContent;